export const getNotify = async () => {
  return {
    isShow: false,
    popupShow: false,
    title: '',
    content: '',
    body: '',
    type: 'info',
    width: 800,
    url: '',
    image: '',
    startDate: null,
    endDate: null,
  };
};
